interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function FolderIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M10.6667 14.2222H12C12.3167 14.2222 12.6083 14.0556 12.7667 13.7806L15.8778 8.44722C16.0389 8.17222 16.0389 7.83333 15.8806 7.55556C15.7222 7.27778 15.4306 7.11111 15.1111 7.11111H4C3.68333 7.11111 3.39167 7.27778 3.23333 7.55278L1.33333 10.8083V3.55556C1.33333 3.31111 1.53333 3.11111 1.77778 3.11111H5.04167C5.15833 3.11111 5.27222 3.15833 5.35556 3.24167L6.09167 3.97778C6.675 4.56111 7.46667 4.88889 8.29167 4.88889H11.5556C11.8 4.88889 12 5.08889 12 5.33333V6.22222H13.3333V5.33333C13.3333 4.35278 12.5361 3.55556 11.5556 3.55556H8.29167C7.81944 3.55556 7.36667 3.36945 7.03333 3.03611L6.29722 2.29722C5.96389 1.96389 5.51111 1.77778 5.03889 1.77778H1.77778C0.797222 1.77778 0 2.575 0 3.55556V12.4444C0 13.425 0.797222 14.2222 1.77778 14.2222H2.43611H10.6667Z" />
    </svg>
  );
}
